function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 2.216,
  y: 86.076,
  fill: "#D80027",
  width: 509.784,
  height: 339.848
});

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "209.455,154.969 159.219,180.236 209.455,205.493 159.219,230.76 209.455,256.017   159.219,281.283 209.455,306.54 159.219,331.808 209.455,357.065 159.219,382.332 209.455,407.6 173.005,425.93 0,425.93 0,86.07   172.939,86.07 209.455,104.434 159.219,129.701 "
});

var SvgBh = function SvgBh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 85.333 512 341.333",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BH.82818ede.svg";
export { ForwardRef as ReactComponent };